const TeamAvatar = ({ team, className }) => {
  return team?.avatar ? <img className={className} src={team?.avatar} /> : ''
}
export default TeamAvatar
